var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "34px",
    viewBox: "0 0 31 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.0_Cadastro-do-usuario---menu-aberto",
    transform: "translate(-56.000000, -548.000000)",
    fill: "#2B2B2B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(50.000000, 546.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.053,7.9993612 L7.53589838,8.87564435 C6.57931314,9.4279291 6.25156283,10.6511099 6.80384758,11.6076952 L6.80384758,11.6076952 L7.299,12.4663612 L7.3,33.7 C7.3,34.2128358 7.68604019,34.6355072 8.18337887,34.6932723 L8.3,34.7 L15.7,34.7 C16.2128358,34.7 16.6355072,34.3139598 16.6932723,33.8166211 L16.7,33.7 L16.7,28.7493612 L18,31.0003612 L18,34 C18,35.1045695 17.1045695,36 16,36 L8,36 C6.8954305,36 6,35.1045695 6,34 L6,10 C6,8.8954305 6.8954305,8 8,8 L9.053,7.9993612 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42056443,7.78756443 L7.87564435,10.4641016 C7.3233596,11.4206869 7.65110991,12.6438677 8.60769515,13.1961524 L8.60769515,13.1961524 L9.52956443,13.7275644 L19.7796806,31.4824972 C20.0360985,31.9266261 20.5817548,32.0996501 21.0413453,31.9010068 L21.145706,31.8485226 L27.554294,28.1485226 C27.9984229,27.8921047 28.1714469,27.3464484 27.9728036,26.8868579 L27.9203194,26.7824972 L25.8095644,23.1275644 L28.0615644,24.4275644 L29.1961524,26.3923048 C29.7484372,27.3488901 29.4206869,28.5720709 28.4641016,29.1243557 L21.5358984,33.1243557 C20.5793131,33.6766404 19.3561323,33.3488901 18.8038476,32.3923048 L6.80384758,11.6076952 C6.25156283,10.6511099 6.57931314,9.4279291 7.53589838,8.87564435 L9.42056443,7.78756443 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,2.27373675e-13 C27.1045695,2.27170769e-13 28,0.8954305 28,2 L28,26 C28,27.1045695 27.1045695,28 26,28 L18,28 C16.8954305,28 16,27.1045695 16,26 L16,2 C16,0.8954305 16.8954305,2.27576582e-13 18,2.27373675e-13 L26,2.27373675e-13 Z M25.7,1.3 L18.3,1.3 C17.7477153,1.3 17.3,1.74771525 17.3,2.3 L17.3,2.3 L17.3,25.7 C17.3,26.2522847 17.7477153,26.7 18.3,26.7 L18.3,26.7 L25.7,26.7 C26.2522847,26.7 26.7,26.2522847 26.7,25.7 L26.7,25.7 L26.7,2.3 C26.7,1.74771525 26.2522847,1.3 25.7,1.3 L25.7,1.3 Z",
    id: "Combined-Shape",
    transform: "translate(22.000000, 14.000000) rotate(-60.000000) translate(-22.000000, -14.000000) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 13,
    y: 8,
    width: 4,
    height: 4,
    rx: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.a06510f4514d311d12a57184ff67c55d.svg";
export { ForwardRef as ReactComponent };